import type {
  EvenementMobilisationId,
  EvenementRencontreId,
  EvenementVisioId,
  EvenementVisiteId,
  ProductReference,
  ProductSpecificationSlug,
  PublicationType,
} from "agir-types";

export function absoluteUrl(
  path: string,
  base = process.env["NEXT_PUBLIC_BASE_URL"]!,
): string {
  return `${base}${path}`;
}

export function pathToActualite(slug: string): string {
  return `${pathToActualites}/${encodeURIComponent(slug)}`;
}

export const pathToAccueilSocietaire = "/societaire";
export const pathToActualites = "/actualites";

export function pathToActualitesFiltered({
  page,
  type,
}: {
  page?: number | undefined;
  type?: PublicationType | undefined;
} = {}): string {
  const params = new URLSearchParams();
  if (page !== undefined && page > 1) {
    params.set("page", String(page));
  }
  if (type !== undefined) {
    params.set("type", type);
  }
  const queryString = params.toString();
  return queryString ? `${pathToActualites}?${queryString}` : pathToActualites;
}

export const pathToActualitesRss = "/actualites.xml";

export const pathToAdhesion = "/adhesion";

export const pathToAdhesionStep = [
  "informations",
  "paiement",
  "confirmation",
].map((step) => `${pathToAdhesion}/${step}`);

export const pathToApiProxy = "/api";

export const pathToAuth = "/auth";

export const pathToBulletinDeSouscription = `${pathToApiProxy}/profil/bulletin-de-souscription.pdf`;

export function pathToAuthLogin(returnTo?: string): string {
  return `${pathToAuth}/login${returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : ""}`;
}

export const pathToAuthLogout = `${pathToAuth}/logout`;

export const pathToCodesBarres = "/codes-barres-produits";

export const pathToCommunaute = `${pathToAccueilSocietaire}/communaute`;

export function pathToCommuniquePresse(slug: string): string {
  return `/presse/communiques/${encodeURIComponent(slug)}`;
}

export function pathToConsultation(slug: string): string {
  return `/consultations/${encodeURIComponent(slug)}`;
}

export const pathToContactezNous = pathToEditorialPage("contactez-nous");

export const pathToDemarche = pathToEditorialPage(
  "demarche-collective-et-solidaire",
);

export function pathToEditorialPage(slug: string): string {
  return `/p/${encodeURIComponent(slug)}`;
}

export const pathToPresse = "/presse";

export const pathToEvenements = `${pathToAccueilSocietaire}/evenements`;

export const pathToHistoire = pathToEditorialPage(
  "nos-convictions-et-notre-histoire-collective",
);

export function pathToInscription(slug: string): string {
  return `${pathToAccueilSocietaire}/inscriptions/${encodeURIComponent(slug)}`;
}

export const pathToLogo512 = "/logos/cqlp-512.png";

export const pathToMentionsLegales = pathToEditorialPage("mentions-legales");

export function pathToMobilisation(id: EvenementMobilisationId): string {
  return `${pathToAccueilSocietaire}/evenements/mobilisations/${encodeURIComponent(id)}`;
}

export const pathToOuVaNotreArgent = pathToEditorialPage("ou-va-notre-argent");

export const pathToParutionsPresse = "/presse/parutions";

export function pathToParutionPresse(slug: string): string {
  return `${pathToParutionsPresse}/${encodeURIComponent(slug)}`;
}

export function pathToParutionsPresseAtPage(page?: number): string {
  return page !== undefined && page > 1
    ? `${pathToParutionsPresse}?page=${page}`
    : pathToParutionsPresse;
}

export const pathToPointsDeVente = "/points-de-vente";

export const pathToPolitiqueDeConfidentialite = pathToEditorialPage(
  "politique-de-confidentialite",
);

export function pathToProduit(reference: null | ProductReference): string {
  return reference
    ? `${pathToProduits}/${encodeURIComponent(reference.slug)}`
    : pathToProduits;
}

export const pathToProduits = "/produits";

export const pathToProfil = `${pathToAccueilSocietaire}/profil`;

export const pathToPublication: Record<
  PublicationType,
  (slug: string) => string
> = {
  actualite: pathToActualite,
  consultation: pathToConsultation,
};

export function pathToQuestionnaireEnd(
  productSpecificationSlug: ProductSpecificationSlug,
): string {
  return `${pathToQuestionnaires}/${encodeURIComponent(productSpecificationSlug)}/fin`;
}

const pathToQuestionnaires = "/questionnaires";

export function pathToQuestionnaireStart(
  productSpecificationSlug: ProductSpecificationSlug,
): string {
  return `${pathToQuestionnaires}/${encodeURIComponent(productSpecificationSlug)}/intro`;
}

export function pathToQuestionnaireVote(
  productSpecificationSlug: ProductSpecificationSlug,
): string {
  return `${pathToQuestionnaires}/${encodeURIComponent(productSpecificationSlug)}/vote`;
}

export function pathToRencontre(id: EvenementRencontreId): string {
  return `${pathToAccueilSocietaire}/evenements/rencontres/${encodeURIComponent(id)}`;
}

export function pathToRessource(slug: string): string {
  return `${pathToRessources}/${encodeURIComponent(slug)}`;
}

const pathToRessources = `${pathToAccueilSocietaire}/ressources`;

export const pathToSitemap = "/sitemap.xml";

export const pathToStatuts = pathToEditorialPage("statuts-lsdc");

export function pathToVisio(id: EvenementVisioId): string {
  return `${pathToAccueilSocietaire}/evenements/visios/${encodeURIComponent(id)}`;
}

export function pathToVisite(id: EvenementVisiteId): string {
  return `${pathToAccueilSocietaire}/evenements/visites/${encodeURIComponent(id)}`;
}
